import tw, { styled } from 'twin.macro';

export const ModalWrapper = styled.div(() => [
  tw`text-xl px-4 py-6 items-center`,
]);

export const ShopImg = tw.img`block w-36 sm:w-48`;
